import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { BoardScene } from "./BoardScene";

export class BackgroundContainer extends Phaser.GameObjects.Container {

    private background: Phaser.GameObjects.Image;
    private gradientTop: Phaser.GameObjects.Image;
    private gradientBottom: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT / 2 - 400 * GameVars.scaleY;
        this.scaleY = GameVars.scaleY;

        this.background = new Phaser.GameObjects.Image(this.scene, 0, 0, "bg");
        this.add(this.background);

        this.gradientTop = new Phaser.GameObjects.Image(this.scene, 0, 480, "texture_atlas_1", "bg_glow");
        this.gradientTop.scaleX = GameConstants.GAME_WIDTH;
        this.add(this.gradientTop);

        this.gradientBottom = new Phaser.GameObjects.Image(this.scene, 0, (-this.y + GameConstants.GAME_HEIGHT )/ GameVars.scaleY, "texture_atlas_1", "gradient_bottom");
        this.gradientBottom.setOrigin(.5, 1);
        this.add(this.gradientBottom);

        const n = 54;

        const scale = 1 - n / 50 * .5;

        this.background.setScale(scale);

        this.gradientTop.alpha = 1 - n / 50;
    }

    public startGame(): void {

        // cartas que hay en la baraja
        const state = GameVars.cardCrawlEngine?.getState();

        const deck = state.deck;

        const n = deck.length;

        const scale = 1 - n / 50 * .5;

        this.background.setScale(scale);

        this.gradientTop.alpha = 1 - n / 50;

    }

    public onActionProcessed(): void {

        // AVERIGUAR SI SE HAN REPARTIDO CARTAS
        const state = GameVars.cardCrawlEngine.getState();
        const upperTableau = state.upperTableau;

        const cardsDealt = upperTableau.some(card => card !== null && card.uiData && card.uiData.spawned);

        if (cardsDealt) {

            const state = GameVars.cardCrawlEngine.getState();
            const deck = state.deck;
    
            const n = deck.length;
    
            const scale = 1 - n / 50 * .5;

            // NO SE VUELVE ATRAS
            if (scale > this.background.scaleX) {

                this.scene.tweens.add({
                    targets: this.background,
                    scaleX: scale,
                    scaleY: scale,
                    duration: 1750,
                    delay: 1500,
                    ease: Phaser.Math.Easing.Cubic.Out
                });
    
                this.scene.tweens.add({
                    targets: this.gradientTop,
                    alpha: 1 - n / 50,
                    duration: 1750,
                    delay: 1500,
                    ease: Phaser.Math.Easing.Cubic.Out
                });
            }
        }  
    }

    public onGameOver(): void {

        this.scene.tweens.add({
            targets: [this.gradientTop, this.gradientBottom],
            alpha: 0,
            duration: 400,
            ease: Phaser.Math.Easing.Cubic.Out,
            delay: BoardScene.DELAY_GAME_OVER,
            onComplete: () => this.gradientTop.visible = false,
            onCompleteScope: this
        });

        if (GameVars.victory) {

            this.scene.tweens.add({
                targets: this.background,
                scaleX: 1,
                scaleY: 1,
                duration: 2000,
                delay: 2000 + BoardScene.DELAY_GAME_OVER,
                ease: Phaser.Math.Easing.Cubic.Out
            });

        } else {

            const n = 54;

            const scale = 1 - n / 50 * .5;

            this.scene.tweens.add({
                targets: this.background,
                scaleX: scale,
                scaleY: scale,
                duration: 2000,
                delay: BoardScene.DELAY_GAME_OVER,
                ease: Phaser.Math.Easing.Cubic.Out
            });
        }
    }
}
